import { render, staticRenderFns } from "./RefundPanel.vue?vue&type=template&id=2463b6ee&scoped=true&"
import script from "./RefundPanel.vue?vue&type=script&lang=js&"
export * from "./RefundPanel.vue?vue&type=script&lang=js&"
import style0 from "./RefundPanel.vue?vue&type=style&index=0&id=2463b6ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2463b6ee",
  null
  
)

export default component.exports